import { useState } from 'react';

export default function usePortfolioForm(initialName = '') {
  const [portfolioName, setPortfolioName] = useState<string>(initialName);
  const [error, setError] = useState<string>('');

  const handlePortfolioNameChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = e.target;
    setPortfolioName(value);

    const trimmedValue = value.trim(); // Trim the input value
    const regex = /^[a-zA-Z0-9\s]+$/; // Allow letters, numbers, and spaces
    if (!trimmedValue) {
      setError('');
      return;
    }

    if (!regex.test(trimmedValue)) {
      setError('Portfolio Name cannot contain special characters');
      return;
    }

    setError('');
  };

  const resetForm = () => {
    setPortfolioName('');
    setError('');
  };

  return {
    portfolioName,
    error,
    setPortfolioName,
    handlePortfolioNameChange,
    resetForm,
  };
}
